/*
 * @Author: Axs <i@axs.email>
 * @Date: 2020-08-04 20:51:36
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-06-30 14:29:19
 * @Description: 常量文件
 * @FilePath: /src/lib/constant.js
 */
// util
import {
    PAGE_ORDER_LIST,
    PAGE_CUSTOMER_SERVICE,
    PAGE_MAIN_MOVIE,
    PAGE_MAIN_CINEMA,
    PAGE_COUPON_LIST,
} from 'page';
// 项目简称
export const QZ_ABBREVIATION = '电影';
// 千猪特殊Token
export const QZ_SPECIAL_TOKEN = 'QZ_SPECIAL_TOKEN';
// 千猪缓存名称
export const QZ_TOKEN = 'QZ_TOKEN';
// 千猪平台id
export const QZ_PLATFORM_ID = 'QZ_PLATFORM_ID';
// 千猪子平台id
export const QZ_SUB_PLATFORM_ID = 'QZ_SUB_PLATFORM_ID';
// 当前浏览器定位
export const LOCATION_CURRENT = 'QZ_LOCATION_CURRENT';
// 用户设定的定位
export const LOCATION_SET = 'QZ_LOCATION_SET';
// Toast 停留时长(ms)
export const TOAST_STOP_TIME = 1500;
// 获取授权未知时长
export const GET_LOCATION_TIME = 5000;
// 电影票最多可选的位置数量 选择我们平台出票数量
// export const MOVIE_SINGLE_QUOTA_NUMBER = 6;
export const MOVIE_SINGLE_QUOTA_NUMBER = 4;
// 电影票qmm 出票模式
export const MOVIE_SINGLE_QUOTA_NUMBER_OF_QMM = 4;
// 千猪页面传输名称
export const QZ_ROUTER_PARAMS = 'QZ_ROUTER_PARAMS';
// 千猪历史访问缓存列表
export const QZ_LOCATION_HISTORY_LIST = 'QZ_LOCATION_HISTORY_LIST';
// 千猪电影票已经浏览的订单id
export const QZ_MOVIE_ID_LOOK_LIST = 'QZ_MOVIE_ID_LOOK_LIST';
// 当前环境值来源类型
export const QZ_SCENE_TYPE = 'QZ_SCENE_TYPE';
// 当前环境场景值
export const QZ_CURRENT_SCENE_VALUE = 'QZ_CURRENT_SCENE';
// 渠道用户用户Id
export const QZ_PLATFORM_USER_OPEN_ID = 'QZ_PLATFORM_USER_OPEN_ID';
// 渠道用户openId
export const QZ_PLATFORM_APP_ID = 'QZ_PLATFORM_APP_ID';
// 微信openId
export const QZ_WX_OPEN_ID = 'QZ_WX_OPEN_ID';
// 商户id
export const QZ_MERCH_ID = 'QZ_MERCH_ID';
// 推广员id
export const QZ_PROMOTER_ID = 'QZ_PROMOTER_ID';
// 客服配置
export const QZ_KF_CONFIG = {
    SOURCE: '电影票',
    CHANNEL_ID: '6265',
    CHANNEL_KEY: '6265tiwn',
    WECHATAPP_ID: '129745',
    KEY: '11272kto0',
};
// 骑士卡客服配置
export const QZ_KF_QSK_CONFIG = {
    SOURCE: '电影票',
    CHANNEL_ID: '31709',
    CHANNEL_KEY: '31709caz7',
    WECHATAPP_ID: '129745',
    KEY: '696226tv5',
};

// main tabber list
export const MAIN_TABBER_LIST = [
    {
        icon: require('@/assets/icons/icon-tabber-movie.png'),
        selectIcon: require('@/assets/icons/icon-tabber-movie-on.png'),
        name: '电影',
        path: PAGE_MAIN_MOVIE,
    },
    {
        icon: require('@/assets/icons/icon-tabber-cinema.png'),
        selectIcon: require('@/assets/icons/icon-tabber-cinema-on.png'),
        name: '影院',
        path: PAGE_MAIN_CINEMA,
    },
];
// 当前环境参数代表
export const QZ_CURRENT_SCENE = {
    APP: 1000, // 普通app && 其他浏览器
    APP_MG: 1001, // 美逛app
    WX_MIN: 2000, // 微信小程序
    WX_BROWSER: 3000, // 微信浏览器
    TT_MIN: 4000, // 头条小程序
    ALIPAY_BROWSER: 5000, // 支付宝浏览器
    ALIPAY_MIN: 6000, // 支付宝小程序
    BD_MIN: 7000, // 百度小程序
    STEP: 1000, // 俩俩之间间隔
};
// 支付方式
export const QZ_PAY_TYPE = {
    ALIPAY_H5: 1, // 支付宝H5支付
    ALIPAY_MIN: 2, // 支付宝小程序支付
    WXPAY_H5: 3, // 微信H5支付
    WXPAY_MIN: 4, // 微信小程序支付
    WXPAY_BROWSER: 5, // 微信浏览器支付
    TTPAY_MIN: 6, // 头条小程序支付
    BDPAY_MIN: 7, //  百度小程序支付
    OTHERPAY: 99,
};
// 当前默认首页金刚区
export const QZ_INDEX_ICON_LIST = () => {
    let currentScene = '';
    if (navigator && navigator.userAgent) {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
            wx.miniProgram.getEnv(res => {
                if (res.miniprogram) {
                    currentScene = QZ_CURRENT_SCENE.WX_MIN;
                } else {
                    currentScene = QZ_CURRENT_SCENE.WX_BROWSER;
                }
            });
        } else {
            currentScene = QZ_CURRENT_SCENE.APP;
        }
    } else {
        currentScene = QZ_CURRENT_SCENE.APP;
    }
    if (currentScene != QZ_CURRENT_SCENE.WX_BROWSER || process.env.VUE_APP_BASE_URL) {
        return [
            {
                code: '',
                createTime: '2019-10-22 17:44:52',
                extraParam: {},
                imageUrl: require('@/assets/icons/icon-ticket-collection.png'),
                isAuthentication: false,
                isIcon: false,
                message: '',
                name: '取票码',
                path: PAGE_ORDER_LIST,
                type: 2,
                updateTime: '',
            },
            {
                code: '',
                createTime: '2019-10-22 17:44:52',
                extraParam: {},
                imageUrl: require('@/assets/icons/icon-order.png'),
                isAuthentication: false,
                isIcon: false,
                message: '',
                name: '订单',
                path: PAGE_ORDER_LIST,
                type: 2,
                updateTime: '',
            },
            {
                code: '',
                createTime: '2022-06-30 00:00:00',
                extraParam: {},
                imageUrl: require('@/assets/icons/icon-card.png'),
                isAuthentication: false,
                isIcon: false,
                message: '',
                name: '优惠券',
                path: PAGE_COUPON_LIST,
                type: 2,
                updateTime: '',
            },
            {
                code: '',
                createTime: '2019-10-22 17:44:52',
                extraParam: {},
                imageUrl: require('@/assets/icons/icon-customer-service.png'),
                isAuthentication: false,
                isIcon: false,
                message: '',
                name: '客服',
                path: PAGE_CUSTOMER_SERVICE,
                type: 2,
                updateTime: '',
            },
        ];
    } else {
        return [
            {
                code: '',
                createTime: '2019-10-22 17:44:52',
                extraParam: {},
                imageUrl: require('@/assets/icons/icon-ticket-collection.png'),
                isAuthentication: false,
                isIcon: false,
                message: '',
                name: '取票码',
                path: PAGE_ORDER_LIST,
                type: 2,
                updateTime: '',
            },
            {
                code: '',
                createTime: '2019-10-22 17:44:52',
                extraParam: {},
                imageUrl: require('@/assets/icons/icon-order.png'),
                isAuthentication: false,
                isIcon: false,
                message: '',
                name: '订单',
                path: PAGE_ORDER_LIST,
                type: 2,
                updateTime: '',
            },
            {
                code: '',
                createTime: '2022-06-30 00:00:00',
                extraParam: {},
                imageUrl: require('@/assets/icons/icon-card.png'),
                isAuthentication: false,
                isIcon: false,
                message: '',
                name: '优惠券',
                path: PAGE_COUPON_LIST,
                type: 2,
                updateTime: '',
            },
            {
                code: '',
                createTime: '2019-10-22 17:44:52',
                extraParam: {},
                imageUrl: require('@/assets/icons/icon-customer-service.png'),
                isAuthentication: false,
                isIcon: false,
                message: '',
                name: '客服',
                path: PAGE_CUSTOMER_SERVICE,
                type: 2,
                updateTime: '',
            },
        ];
    }
};
